import React, { useEffect, useContext, useState } from "react";

//global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

//schema state context
import { SchemaAddClassStateProvider } from "./SchemaAddClassStateContext";

//helper functions
import { getSchema } from "./helpers";

//components
import Spinner from "../../components/console/Spinner";
import WeaviateErrorPage from "../../components/console/WeaviateErrorPage";
import SchemaRoutes from "./SchemaRoutes";

//Styling
import "./style.scss";

//to use history
import { useHistory } from "react-router-dom";

const Module = () => {
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);
  const [schema, setSchema] = useState(null);

  //to push to browser's history
  const history = useHistory();

  useEffect(() => {
    getSchema(state, setState, setSchema, history);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.schema.schemaUpdate]);

  console.log(schema);

  if (schema) {
    return (
      <div className="__SchemaModule">
        <SchemaAddClassStateProvider>
          <SchemaRoutes schema={schema || null} />
        </SchemaAddClassStateProvider>
      </div>
    );
  } else if (state.connectToWeaviateURI === "") {
    return <WeaviateErrorPage />;
  } else {
    return (
      <div className="__SchemaModule">
        <Spinner />
      </div>
    );
  }
};

export default Module;
